import { render } from "./CV.vue?vue&type=template&id=27a7a082&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import "./CV.vue?vue&type=style&index=0&id=27a7a082&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27a7a082"

export default script